import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const imgWithTextCard = () => {
    const select = document.querySelectorAll('.img-card-group');
    const tl = gsap.timeline();

    gsap.matchMedia().add(
        "(min-width: 900px)", () => {
            select.forEach( e => {
                const main = e.querySelectorAll('.img-with-text-card');
                main.forEach( (el, i) => {
                    let val, startVal, endVal;
                    
        
                    val = (i + 0.8) * 120;
                    startVal = 'top bottom';
                    endVal = 'bottom +=30%';                 
                    !e.classList.contains('img-card-group--number') ?
                    tl.from(el, {
                        y: val,
                        scrollTrigger: {
                            trigger: el.querySelector('.img-with-text-card__img'),
                            start: startVal,
                            end: endVal,
                            scrub: true
                        }
                    }) : 
                    tl.from(el, {
                        y: val,
                        scrollTrigger: {
                            trigger: el.querySelector('.img-with-text-card__img'),
                            start: startVal,
                            end: endVal,
                            scrub: true
                        }
                    })
                    .from(el.querySelector('.img-with-text-card__img'), {
                        '--move': '100%',
                        scrollTrigger: {
                            trigger: el.querySelector('.img-with-text-card__img'),
                            start: 'top bottom',
                            end: '50% 50%',
                            scrub: true
                        }
                    });
                })
            })
        }
    )
}
